import { render } from "./FoliosEnrollmentEdit.vue?vue&type=template&id=1038bcc3&scoped=true&ts=true"
import script from "./FoliosEnrollmentEdit.vue?vue&type=script&lang=ts"
export * from "./FoliosEnrollmentEdit.vue?vue&type=script&lang=ts"

import "./FoliosEnrollmentEdit.vue?vue&type=style&index=0&id=1038bcc3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1038bcc3"]])

export default __exports__